import { useMembershipModalState } from '../../modalContext';

export function useShowPaypalButton(): boolean {
	const [
		{
			paymentType,
			usingSavedPaymentMethod,
			acceptMembership,
			tokenizationData,
			savingBraintreePaymentTemporarilyEnabled,
		},
	] = useMembershipModalState();

	return (
		paymentType === 'paypal' &&
		!usingSavedPaymentMethod &&
		tokenizationData?.tokenType !== 'permanent' &&
		!savingBraintreePaymentTemporarilyEnabled &&
		acceptMembership
	);
}
